/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ExecRiskApiAppApiV1EagerTasksForm990ModelsIRS990ContractorCompensationContractor } from './ExecRiskApiAppApiV1EagerTasksForm990ModelsIRS990ContractorCompensationContractor';
import {
    ExecRiskApiAppApiV1EagerTasksForm990ModelsIRS990ContractorCompensationContractorFromJSON,
    ExecRiskApiAppApiV1EagerTasksForm990ModelsIRS990ContractorCompensationContractorFromJSONTyped,
    ExecRiskApiAppApiV1EagerTasksForm990ModelsIRS990ContractorCompensationContractorToJSON,
} from './ExecRiskApiAppApiV1EagerTasksForm990ModelsIRS990ContractorCompensationContractor';
import type { ExecRiskContractorAddress } from './ExecRiskContractorAddress';
import {
    ExecRiskContractorAddressFromJSON,
    ExecRiskContractorAddressFromJSONTyped,
    ExecRiskContractorAddressToJSON,
} from './ExecRiskContractorAddress';

/**
 * 
 * @export
 * @interface ExecRiskContractorCompensation
 */
export interface ExecRiskContractorCompensation {
    /**
     * 
     * @type {ExecRiskApiAppApiV1EagerTasksForm990ModelsIRS990ContractorCompensationContractor}
     * @memberof ExecRiskContractorCompensation
     */
    ContractorName?: ExecRiskApiAppApiV1EagerTasksForm990ModelsIRS990ContractorCompensationContractor;
    /**
     * 
     * @type {ExecRiskContractorAddress}
     * @memberof ExecRiskContractorCompensation
     */
    ContractorAddress?: ExecRiskContractorAddress;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskContractorCompensation
     */
    ServicesDesc?: string;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskContractorCompensation
     */
    CompensationAmt?: number;
}

/**
 * Check if a given object implements the ExecRiskContractorCompensation interface.
 */
export function instanceOfExecRiskContractorCompensation(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ExecRiskContractorCompensationFromJSON(json: any): ExecRiskContractorCompensation {
    return ExecRiskContractorCompensationFromJSONTyped(json, false);
}

export function ExecRiskContractorCompensationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskContractorCompensation {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'ContractorName': !exists(json, 'ContractorName') ? undefined : ExecRiskApiAppApiV1EagerTasksForm990ModelsIRS990ContractorCompensationContractorFromJSON(json['ContractorName']),
        'ContractorAddress': !exists(json, 'ContractorAddress') ? undefined : ExecRiskContractorAddressFromJSON(json['ContractorAddress']),
        'ServicesDesc': !exists(json, 'ServicesDesc') ? undefined : json['ServicesDesc'],
        'CompensationAmt': !exists(json, 'CompensationAmt') ? undefined : json['CompensationAmt'],
    };
}

export function ExecRiskContractorCompensationToJSON(value?: ExecRiskContractorCompensation | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ContractorName': ExecRiskApiAppApiV1EagerTasksForm990ModelsIRS990ContractorCompensationContractorToJSON(value.ContractorName),
        'ContractorAddress': ExecRiskContractorAddressToJSON(value.ContractorAddress),
        'ServicesDesc': value.ServicesDesc,
        'CompensationAmt': value.CompensationAmt,
    };
}

